import { useCallback, useEffect } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import {
    modalSearchAwbState,
    searchAwbNumState,
    searchAwbDataMapState,
    additionalSearchAwbDataState,
    loadingState
} from './atoms';
import apiClient from '../../apiClient';
import { validateAwb } from '../../utils';
import useUser from '../../customHooks/useUser';

export const useSearchAwb = () => {
    const { user: { s_unit } } = useUser();
    const [searchAwbNum, setSearchAwbNum] = useRecoilState(searchAwbNumState);
    const [searchAwbDataMap, setSearchAwbDataMap] = useRecoilState(searchAwbDataMapState);
    const [modalSearchAwb, setModalSearchAwb] = useRecoilState(modalSearchAwbState);
    const [additionalSearchAwbData, setAdditionalSearchAwbData] = useRecoilState(additionalSearchAwbDataState);
    const [loading, setLoading] = useRecoilState(loadingState);

    const handleSearchAwb = useCallback(async (e, overrideSearchAwb = null) => {
        if (e) {
            e.preventDefault();
        }

        if (overrideSearchAwb) {
            setSearchAwbNum(overrideSearchAwb);
        }

        const s_mawb = overrideSearchAwb || searchAwbNum;
        const normalized = (s_mawb || '').replace(/-/g, '');

        if (normalized && normalized.length === 11 && validateAwb(normalized)) {
            setLoading(true);
            setModalSearchAwb(true);

            try {
                const res = await apiClient.post('searchAwbDashboard', {
                    s_mawb,
                    s_unit,
                    map: searchAwbDataMap,
                    s_airline_codes: []
                });

                if (res.status === 200) {
                    setSearchAwbDataMap(res.data.map);
                    setAdditionalSearchAwbData(res.data.additional);
                }
            } catch (error) {
                console.error('Search AWB error:', error);
                // Handle error appropriately
            } finally {
                setLoading(false);
            }
        }
    }, [
        searchAwbDataMap,
        searchAwbNum,
        s_unit,
        setSearchAwbNum,
        setSearchAwbDataMap,
        setModalSearchAwb,
        setAdditionalSearchAwbData,
        setLoading
    ]);

    return {
        searchAwbNum,
        setSearchAwbNum,
        searchAwbDataMap,
        setSearchAwbDataMap,
        modalSearchAwb,
        setModalSearchAwb,
        additionalSearchAwbData,
        loading,
        handleSearchAwb
    };
};
